import React, { useEffect, useState } from 'react';
import MuiCheckbox from '@mui/material/Checkbox';

const Checkbox = ({ isChecked, onChange, disabled, className = '', size, ...props }) => {
  const [checked, setChecked] = useState(isChecked);

  const handleCheckboxChange = (event, nextChecked) => {
    event.stopPropagation();
    const newChecked = typeof nextChecked === 'boolean' ? nextChecked : event.target.checked;
    setChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <MuiCheckbox
      disabled={disabled}
      checked={checked}
      size={size}
      onChange={handleCheckboxChange}
      className={`pointer ${className}`.trim()}
      {...props}
    />
  );
};

export default Checkbox;
